import React, { Fragment, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getDestination, getMerchandise } from 'store/destination/destinationSelectors';
import Header from 'pages/Destination/Header';
import InPageNavBar from 'components/InPageNavBar';
import CoreValueProposition from 'pages/Destination/CoreValueProposition';
import DestinationContent from 'pages/Destination/DestinationContent';
import FAQs from 'pages/Destination/FAQs';
import PageBlock from 'components/PageBlock';
import LatestDeals from 'pages/Destination/LatestDeals';
import TopAreas from 'pages/Destination/TopAreas';
import DiscoverMore from 'pages/Destination/DiscoverMore';
import { PageBlockPorcelain, PageBlockWhite } from 'pages/Destination/Templates/primitives';
import { Flex } from 'roo-ui/components';
import LegacyBrowserBoundary from 'components/LegacyBrowserBoundary';

const CityTemplate = () => {
  const { discoverMoreAreas, regionName } = useSelector(getDestination);
  const { subRegions } = useSelector(getMerchandise);
  const hasSubRegions = !isEmpty(subRegions);

  const menuItems = [
    { id: 'deals', name: 'deals', ref: useRef(), text: 'Latest deals' },
    { id: 'destination-content', name: 'destination-content', ref: useRef(), text: `Discover ${regionName}` },
    { id: 'faqs', name: 'faqs', ref: useRef(), text: 'Frequently asked questions' },
  ];

  const getMenuRef = useCallback((name) => menuItems.find((item) => item.name === name).ref, [menuItems]);

  return (
    <Fragment>
      <Header headingText={`${regionName} Hotels`} pb={0} bg="white" />
      <InPageNavBar menuItems={menuItems} shadow />

      <LegacyBrowserBoundary>
        <PageBlock id="deals" pt={15} pb={5} bg="greys.porcelain" ref={getMenuRef('deals')}>
          <LatestDeals />
        </PageBlock>
      </LegacyBrowserBoundary>

      {hasSubRegions && (
        <PageBlockPorcelain>
          <TopAreas areas={subRegions} regionName={regionName} title="Top areas" />
        </PageBlockPorcelain>
      )}

      <Flex
        id="destination-content"
        pb={10}
        alignItems="center"
        backgroundColor="white"
        flexDirection="column"
        ref={getMenuRef('destination-content')}
      >
        <DestinationContent />
      </Flex>

      <PageBlockPorcelain>
        <CoreValueProposition />
      </PageBlockPorcelain>

      <PageBlock id="faqs" pb={10} bg="porcelain" ref={getMenuRef('faqs')}>
        <FAQs />
      </PageBlock>

      {discoverMoreAreas && (
        <PageBlockWhite>
          <DiscoverMore areas={discoverMoreAreas} headingText="Discover more" />
        </PageBlockWhite>
      )}
    </Fragment>
  );
};

export default CityTemplate;
